import NoSsr from '@eversports/klimt-design-components/NoSsr'

import Footer from './Footer'
import Header from './Header'
import LoadingMatch from './LoadingMatch'
import Match from './Match'

const MatchPage = () => {
  return (
    <>
      <Header />
      <NoSsr fallback={<LoadingMatch />}>
        <Match />
        <Footer />
      </NoSsr>
    </>
  )
}

export default MatchPage
